import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import Auth from "./pages/Auth";
import Chat from "./pages/Chat";
import Plans from "./pages/Plans";
import Nangcap from "./pages/Nangcap";
import TransactionHistory from "./pages/TransactionHistory";
import Contact from "./pages/Contact";
import { useEffect, useState } from "react";
import { supabase } from "./integrations/supabase/client";
import { Session } from "@supabase/supabase-js";

const queryClient = new QueryClient();

const AppContent = () => {
  const location = useLocation();
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const showSidebar = location.pathname !== "/" || session;

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        {showSidebar && <AppSidebar />}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Auth />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/nangcap" element={<Nangcap />} />
            <Route path="/transactions" element={<TransactionHistory />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </SidebarProvider>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;